import { render, staticRenderFns } from "./FixedPlugin.vue?vue&type=template&id=6e2efeb7&"
import script from "./FixedPlugin.vue?vue&type=script&lang=js&"
export * from "./FixedPlugin.vue?vue&type=script&lang=js&"
import style0 from "./FixedPlugin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports